//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    },
    help: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},
  methods: {}
};